ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Payloads = require 'network/payloads'
MemberList = undefined
queueRequire -> MemberList = require 'models/collections/member-list'
OrganizationList = undefined
queueRequire -> OrganizationList = require 'models/collections/organization-list'
PendingOrganizationList = undefined
queueRequire -> PendingOrganizationList = require 'models/collections/pending-organization-list'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ModelWithPreferences = require 'models/internal/model-with-preferences'
Organization  = require 'models/organization'
Promise = require 'bluebird'
_ = require 'underscore'
OrgFeatures = require 'data/org-features'
AttachmentTypes = require 'data/attachment-types'

module.exports = class Enterprise extends ModelWithPreferences
  typeName: 'Enterprise'
  nameAttr: 'name'
  urlRoot: '/1/enterprises'

  constructor: ->
    super
    @_initSubEventsOn 'organizationPrefs'
    return

  initialize: ->
    super

    @userTypesLoading = true
    @userTypesLoadFailed = false

    @destruct [
      @organizationList = new OrganizationList()
      @memberList = new MemberList()
      @pendingOrganizationList = new PendingOrganizationList()
    ]

  getOrganizationPref: (name) ->
    @get('organizationPrefs')?[name]

  setOrganizationPref: (name, value, opts, next) ->
    @update "organizationPrefs/#{ name }", value, opts, (err) =>
      unless err
        @_cascadeOrganizationPrefs(name, value)
      if _.isFunction(next)
        next(err)

  # Optimistically update all cached orgs in this enterprise
  _cascadeOrganizationPrefs: (name, value) ->
    @modelCache.all('Organization').filter (cachedOrg) =>
      cachedOrg.get('idEnterprise') == @id
    .forEach (enterpriseOrg) =>
      enterpriseOrg.set { "prefs/#{ name }": value }

  deleteOrganizationPref: (name, next) ->
    @set { "organizationPrefs/#{ name }": undefined }
    @api {
      type: 'delete'
      method: "organizationPrefs/#{ name }"
    }, next


  loadPageOfMembers: (query) ->
    ModelLoader.loadMembersOfEnterprise(@get('name'), query)
    .tap ([members]) =>
      @memberList.add(members) if members.length > 0

  loadUserTypes: ->
    return Promise.resolve() if @userTypesLoadFailed

    @userTypesLoading = true
    @trigger 'loading:userTypes'

    ModelLoader.loadEnterprise @id,
      fields: 'userTypes'
      organizations: 'none'
    # This is currently slow for big enterprises. Swallow timeouts, and you'll
    # need to render the UI as best as you can.
    .catch ApiError.Server, (err) ->
      @userTypesLoadFailed = true
      if err.message != "Gateway Timeout"
        throw err
    .then =>
      @userTypesLoading = false
      @trigger 'change:userTypes'

  loadPageOfOrganizations: (query) ->
    ModelLoader.loadEnterpriseOrganizations(@get('name'), query)
    .tap ([organizations]) =>
      @organizationList.add(organizations) if organizations.length > 0

  loadMaxMembers: ->
    ModelLoader.loadEnterprise @id,
      # load prefs to refresh maxMembers
      fields: 'prefs'
      organizations: 'none'

  loadPageOfPendingOrganizations: (query) ->
    ModelLoader.loadEnterprisePendingOrganizations(@get('name'), query)
    .tap ([pendingOrganizations]) =>
      @pendingOrganizationList.add(pendingOrganizations) if pendingOrganizations.length > 0

  # This is silly, but the enterprises endpoint serves more than actual
  # enterprises. There there's also other "collections of teams" that we use to
  # configure sso and for recurring billing. This is how we tell if something
  # from that endpoint is actually an enterprise:
  isRealEnterprise: ->
    OrgFeatures.isFeatureEnabled('enterpriseUI', @get('products'))

  declinePendingOrganization: (pendingOrganization) ->
    # This is the same as org.cancelEnterpriseJoinRequest, but we can't invoke
    # that from here because the enterprise admin might not have permission to
    # access the org and therefore we might not have the org as a backbone
    # model.
    ApiPromise
      url: "/1/organizations/#{ pendingOrganization.id }/enterpriseJoinRequest"
      type: 'DELETE'
    .then =>
      @pendingOrganizationList.remove(pendingOrganization)

  acceptPendingOrganization: (pendingOrganization) ->
    ApiPromise
      url: "/1/enterprises/#{ @id }/organizations"
      type: 'PUT'
      data:
        idOrganization: pendingOrganization.id
    .then (response) =>
      @pendingOrganizationList.remove(pendingOrganization)

      teamAttrs = if _.isArray(response)
          _.find response, (team) ->
            team.id == pendingOrganization.id
        else
          response

      team = @modelCache.get('Organization', pendingOrganization.id)
      if !team?
        team = new Organization(teamAttrs, modelCache: @modelCache)
      else
        team.set(teamAttrs)

      @organizationList.add(team)
      @trigger 'accept:pendingOrganization', pendingOrganization

  getAvailableLicenses: ->
    if @getPref('maxMembers')?
      return unless @get('userTypes')?
      @getPref('maxMembers') - @get('userTypes').member
    else
      Infinity

  getAttachmentRestrictions: ->
    attachmentRestrictions = @get('organizationPrefs')?.attachmentRestrictions

    if attachmentRestrictions?
      {
        enabled: attachmentRestrictions,
        disabled: _.difference(AttachmentTypes, attachmentRestrictions)
      }
    else
      { enabled: AttachmentTypes, disabled: [] }



// WEBPACK FOOTER //
// ./app/scripts/models/enterprise.coffee